import { PayCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { getAuthData } from '../../../hooks/useAuth';
import { useCrudRecord } from '../../../containers/crud/recordContext';
import { MAIN_WEBSITE_URL } from '../../../constants/api';

export const WebsitePaymentButton = () => {
  const record = useCrudRecord();
  const { key } = record;
  return (
    <Tooltip title="Make Payment" placement="bottom">
      <Button
        className="ant-btn btn edit"
        onClick={() => {
          window.location.href = `${MAIN_WEBSITE_URL}/checkout/website/${btoa(key)}?accessToken=${btoa(getAuthData().accessToken)}`;
        }}
        rel="noreferrer"
      >
        <PayCircleOutlined />
        Pay
      </Button>
    </Tooltip>
  );
};
